import React from "react";
import ProfileFields from "../ProfileFields";
import { MEDICATION_CLASSES } from "../../utils/medicalProfileApi";

const reportedText = (classes) => {
  if (classes == null) return null; // "Not recorded"
  if (classes.length === 0) return "None of these";
  return classes.map((id) => MEDICATION_CLASSES.find((c) => c.id === id)?.label || id).join(", ");
};

/**
 * The patient's medical profile on the provider's chart, read-only: the patient
 * keeps it up to date from their own Profile. Medication alerts are shown above
 * the tabs (MedicationAlertBanner), so they are seen whichever tab is open.
 */
const MedicalInfoTab = ({ profile, loadFailed }) => {
  if (loadFailed) {
    return <p role="alert" style={{ color: "var(--youro-error)", padding: "16px" }}>We couldn't load this patient's medical information. Refresh to try again.</p>;
  }
  if (!profile) return <p style={{ padding: "16px", color: "var(--youro-muted)" }}>Loading…</p>;

  const pharmacy = [profile.pharmacyName, profile.pharmacyAddress].filter(Boolean).join(" — ");
  return (
    <div style={{ padding: "8px 0" }}>
      <ProfileFields
        fields={[
          { label: "Preferred pharmacy", value: pharmacy },
          { label: "Pharmacy phone", value: profile.pharmacyPhone },
          { label: "Pharmacy fax", value: profile.pharmacyFax },
          { label: "Pharmacy NPI", value: profile.pharmacyNpi },
          { label: "Medications", value: profile.medications },
          { label: "Takes nitrates, digoxin, anticholinergics or narcotics (patient's answer)", value: reportedText(profile.reportedMedicationClasses) },
          { label: "Allergies", value: profile.allergies },
          { label: "Medical history", value: profile.medicalHistory },
          { label: "Surgical history", value: profile.surgicalHistory },
        ]}
      />
    </div>
  );
};

export default MedicalInfoTab;
